function belongs_to_menu(id) {
  $('li.menu_item').removeClass('current');
  $(id).addClass('current');
  $(id).parent().closest('li.menu_item').addClass('current');
};
window.belongs_to_menu = belongs_to_menu
